import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails.tsx';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection.tsx';
import type { PackageFormState } from '@openx/types/package.ts';
import { priceFormat } from '@openx/utils/lib/priceFormat.ts';
import { useTranslation } from 'react-i18next';
import { usePackageContext } from '../../../utils/context/PackageContext.tsx';

interface Props {
  pckg: PackageFormState;
}

export function DPackageRates({ pckg }: Props) {
  const { t } = useTranslation();
  const { useRelatedAccountsFetch } = usePackageContext();

  const { relatedAccounts = {}, loading: relatedAccountsLoading } = useRelatedAccountsFetch([pckg]);
  const currency = relatedAccounts[pckg.account_uid]?.currency;

  return (
    <FormSection divider title={t('Direct Package Rates')}>
      <FieldDetails
        title={t('Rate Card Price')}
        loading={relatedAccountsLoading}
        value={priceFormat(pckg.rate_card_cpm || null, currency)}
      />
    </FormSection>
  );
}
